import { UserRound } from 'lucide-react'
import { SiteLayout } from '../components/ui/site-chrome'
import { TrustPage } from '../components/ui/trust-page'

export default function AboutPage() {
  return (
    <SiteLayout
      current="/about"
      title="About Juan Cubeddu | Zadro"
      description="About Juan Cubeddu, fractional CTO, full-stack engineer, AI strategy advisor, and product innovation partner behind Zadro."
    >
      <TrustPage
        Icon={UserRound}
        visual="about"
        eyebrow="About Juan"
        heroTitle="I help founders and teams see the system clearly enough to fix it."
        heroCopy="My work sits between engineering, product, business strategy, and execution. I am useful when a company has ambition, pressure, and complexity, but needs sharper technical leadership to turn effort into outcomes."
        proof={[
          '17+ years of hands-on product and engineering experience.',
          'Experience across e-commerce, startups, real estate technology, cloud, and full-stack systems.',
          'Comfortable working with non-technical founders and technical teams alike.',
        ]}
        cards={[
          {
            title: 'Operator first',
            copy: 'I care about what ships, what breaks, what the customer experiences, and what the team can own after the engagement.',
          },
          {
            title: 'Translator second',
            copy: 'A lot of value comes from turning founder intent into technical direction and turning engineering reality into business decisions.',
          },
          {
            title: 'Builder always',
            copy: 'I do not only advise from a distance. The work is grounded in real systems, real code, real workflows, and real tradeoffs.',
          },
        ]}
        sections={[
          {
            kicker: 'Philosophy',
            title: 'Better wiring before more power.',
            copy: 'Companies often try to scale by adding people, tools, vendors, or budget. But if the wiring is weak, more power only makes the failure more expensive.',
            items: [
              'Find the actual constraint before buying solutions',
              'Use technology to increase clarity and speed, not noise',
              'Build systems that teams understand and can operate',
              'Make AI practical, governed, and tied to measurable business value',
            ],
          },
          {
            kicker: 'How I Show Up',
            title: 'Calm technical leadership in messy moments.',
            copy: 'The best engagements create relief: the team knows where to focus, founders know which decisions matter, and technical work reconnects to business outcomes.',
            items: [
              'Architecture and roadmap review',
              'Founder coaching and decision support',
              'AI strategy and product design',
              'Workshops, diagnostics, and product innovation pilots',
            ],
          },
        ]}
      />
    </SiteLayout>
  )
}
